import { get, pick } from "lodash"
import { createSelector } from "reselect"
import { generateSummaryKey } from "../model"

const EMPTY_OBJECT = {}

export const getAiResource = (state) => get(state, "global.data.aiSummaryResource.data.resource", EMPTY_OBJECT)

export const getSummaryKey = createSelector(
  [getAiResource, (state, props) => props],
  (resource, props) => generateSummaryKey({
    ...pick(props, ["account", "action", "modelId", "startDate", "endDate", "base"]),
    resourceIdOrAlias: resource.alias,
    resourceType: resource.type,
    resourceUpdatedAt: resource.updatedAt,
  }),
)
export const getSummaries = (state) => get(state, "modules.aiSummary", EMPTY_OBJECT)

export const getGeneratedSummary = createSelector(
  [getSummaryKey, getSummaries],
  (summaryKey, summaries) => get(summaries, summaryKey),
)
